export default function Movie() {
    return (
      <div>
        <h1>Films</h1>
      </div>
    );
  }
  